export default {
  id: '3418865',
  name: '导航后台',
  font_family: 'iconfont',
  css_prefix_text: 'icon-',
  description: '',
  glyphs: [
    {
      icon_id: '8448528',
      name: 'CI/CD',
      font_class: 'ziyuan',
      unicode: 'e621',
      unicode_decimal: 58913
    },
    {
      icon_id: '774372',
      name: '工具',
      font_class: 'gongju',
      unicode: 'e614',
      unicode_decimal: 58900
    },
    {
      icon_id: '10199180',
      name: '绑定',
      font_class: 'bangding',
      unicode: 'e615',
      unicode_decimal: 58901
    },
    {
      icon_id: '1166053',
      name: '日志',
      font_class: 'rizhi',
      unicode: 'e61c',
      unicode_decimal: 58908
    },
    {
      icon_id: '687392',
      name: '返回',
      font_class: 'fanhui',
      unicode: 'e6ff',
      unicode_decimal: 59135
    },
    {
      icon_id: '11372639',
      name: '爱心',
      font_class: 'aixin',
      unicode: 'e8ab',
      unicode_decimal: 59563
    },
    {
      icon_id: '11372640',
      name: '编辑',
      font_class: 'bianji',
      unicode: 'e8ac',
      unicode_decimal: 59564
    },
    {
      icon_id: '11372641',
      name: '3D眼镜',
      font_class: 'Dyanjing',
      unicode: 'e8ad',
      unicode_decimal: 59565
    },
    {
      icon_id: '11372642',
      name: '彩蛋',
      font_class: 'caidan',
      unicode: 'e8ae',
      unicode_decimal: 59566
    },
    {
      icon_id: '11372643',
      name: '安全',
      font_class: 'anquan',
      unicode: 'e8af',
      unicode_decimal: 59567
    },
    {
      icon_id: '11372644',
      name: '帮助',
      font_class: 'bangzhu',
      unicode: 'e8b0',
      unicode_decimal: 59568
    },
    {
      icon_id: '11372645',
      name: '不感兴趣',
      font_class: 'buganxingqu',
      unicode: 'e8b1',
      unicode_decimal: 59569
    },
    {
      icon_id: '11372646',
      name: '播放记录',
      font_class: 'bofangjilu',
      unicode: 'e8b2',
      unicode_decimal: 59570
    },
    {
      icon_id: '11372647',
      name: '创作',
      font_class: 'chuangzuo',
      unicode: 'e8b3',
      unicode_decimal: 59571
    },
    {
      icon_id: '11372648',
      name: '成功',
      font_class: 'chenggong',
      unicode: 'e8b4',
      unicode_decimal: 59572
    },
    {
      icon_id: '11372649',
      name: '测试',
      font_class: 'ceshi',
      unicode: 'e8b5',
      unicode_decimal: 59573
    },
    {
      icon_id: '11372650',
      name: '电话',
      font_class: 'dianhua',
      unicode: 'e8b6',
      unicode_decimal: 59574
    },
    {
      icon_id: '11372651',
      name: '点赞',
      font_class: 'dianzan',
      unicode: 'e8b7',
      unicode_decimal: 59575
    },
    {
      icon_id: '11372652',
      name: '定位',
      font_class: 'dingwei',
      unicode: 'e8b8',
      unicode_decimal: 59576
    },
    {
      icon_id: '11372653',
      name: '电筒_关',
      font_class: 'diantong_guan',
      unicode: 'e8b9',
      unicode_decimal: 59577
    },
    {
      icon_id: '11372654',
      name: '电影',
      font_class: 'dianying',
      unicode: 'e8ba',
      unicode_decimal: 59578
    },
    {
      icon_id: '11372655',
      name: '地图',
      font_class: 'ditu',
      unicode: 'e8bb',
      unicode_decimal: 59579
    },
    {
      icon_id: '11372656',
      name: '电筒_开',
      font_class: 'diantong_kai',
      unicode: 'e8bc',
      unicode_decimal: 59580
    },
    {
      icon_id: '11372657',
      name: '电影票',
      font_class: 'dianyingpiao',
      unicode: 'e8bd',
      unicode_decimal: 59581
    },
    {
      icon_id: '11372658',
      name: '订单',
      font_class: 'dingdan',
      unicode: 'e8be',
      unicode_decimal: 59582
    },
    {
      icon_id: '11372659',
      name: '更多',
      font_class: 'gengduo',
      unicode: 'e8bf',
      unicode_decimal: 59583
    },
    {
      icon_id: '11372660',
      name: '翻倍',
      font_class: 'fanbei',
      unicode: 'e8c0',
      unicode_decimal: 59584
    },
    {
      icon_id: '11372661',
      name: '发现',
      font_class: 'faxian',
      unicode: 'e8c1',
      unicode_decimal: 59585
    },
    {
      icon_id: '11372662',
      name: '儿童票',
      font_class: 'ertongpiao',
      unicode: 'e8c2',
      unicode_decimal: 59586
    },
    {
      icon_id: '11372663',
      name: '公益',
      font_class: 'gongyi',
      unicode: 'e8c3',
      unicode_decimal: 59587
    },
    {
      icon_id: '11372664',
      name: '红包',
      font_class: 'hongbao',
      unicode: 'e8c4',
      unicode_decimal: 59588
    },
    {
      icon_id: '11372665',
      name: '复制',
      font_class: 'fuzhi',
      unicode: 'e8c5',
      unicode_decimal: 59589
    },
    {
      icon_id: '11372666',
      name: '分享',
      font_class: 'fenxiang',
      unicode: 'e8c6',
      unicode_decimal: 59590
    },
    {
      icon_id: '11372667',
      name: '话题符号',
      font_class: 'huatifuhao',
      unicode: 'e8c7',
      unicode_decimal: 59591
    },
    {
      icon_id: '11372668',
      name: '会员',
      font_class: 'huiyuan',
      unicode: 'e8c8',
      unicode_decimal: 59592
    },
    {
      icon_id: '11372669',
      name: '阿里鱼',
      font_class: 'aliyu',
      unicode: 'e8c9',
      unicode_decimal: 59593
    },
    {
      icon_id: '11372670',
      name: '机具',
      font_class: 'jiju',
      unicode: 'e8ca',
      unicode_decimal: 59594
    },
    {
      icon_id: '11372671',
      name: '减少',
      font_class: 'jianshao',
      unicode: 'e8cb',
      unicode_decimal: 59595
    },
    {
      icon_id: '11372672',
      name: '卡包',
      font_class: 'kabao',
      unicode: 'e8cc',
      unicode_decimal: 59596
    },
    {
      icon_id: '11372673',
      name: '话题',
      font_class: 'huati',
      unicode: 'e8cd',
      unicode_decimal: 59597
    },
    {
      icon_id: '11372674',
      name: '关注',
      font_class: 'guanzhu',
      unicode: 'e8ce',
      unicode_decimal: 59598
    },
    {
      icon_id: '11372675',
      name: '买一赠一',
      font_class: 'maiyizengyi',
      unicode: 'e8cf',
      unicode_decimal: 59599
    },
    {
      icon_id: '11372676',
      name: '密码',
      font_class: 'mima',
      unicode: 'e8d0',
      unicode_decimal: 59600
    },
    {
      icon_id: '11372677',
      name: '男',
      font_class: 'nan',
      unicode: 'e8d1',
      unicode_decimal: 59601
    },
    {
      icon_id: '11372678',
      name: '女',
      font_class: 'nv',
      unicode: 'e8d2',
      unicode_decimal: 59602
    },
    {
      icon_id: '11372679',
      name: '礼盒',
      font_class: 'lihe',
      unicode: 'e8d3',
      unicode_decimal: 59603
    },
    {
      icon_id: '11372680',
      name: '排行榜',
      font_class: 'paihangbang',
      unicode: 'e8d4',
      unicode_decimal: 59604
    },
    {
      icon_id: '11372681',
      name: '礼品卡',
      font_class: 'lipinka',
      unicode: 'e8d5',
      unicode_decimal: 59605
    },
    {
      icon_id: '11372682',
      name: '朋友圈',
      font_class: 'pengyouquan',
      unicode: 'e8d6',
      unicode_decimal: 59606
    },
    {
      icon_id: '11372683',
      name: '明星活动',
      font_class: 'mingxinghuodong',
      unicode: 'e8d7',
      unicode_decimal: 59607
    },
    {
      icon_id: '11372684',
      name: '取票',
      font_class: 'qupiao',
      unicode: 'e8d8',
      unicode_decimal: 59608
    },
    {
      icon_id: '11372685',
      name: '扫一扫',
      font_class: 'saoyisao',
      unicode: 'e8d9',
      unicode_decimal: 59609
    },
    {
      icon_id: '11372686',
      name: '日历',
      font_class: 'rili',
      unicode: 'e8da',
      unicode_decimal: 59610
    },
    {
      icon_id: '11372687',
      name: '评论',
      font_class: 'pinglun',
      unicode: 'e8db',
      unicode_decimal: 59611
    },
    {
      icon_id: '11372688',
      name: '轻会员',
      font_class: 'qinghuiyuan',
      unicode: 'e8dc',
      unicode_decimal: 59612
    },
    {
      icon_id: '11372689',
      name: '日签',
      font_class: 'riqian',
      unicode: 'e8dd',
      unicode_decimal: 59613
    },
    {
      icon_id: '11372690',
      name: '闪电',
      font_class: 'shandian',
      unicode: 'e8de',
      unicode_decimal: 59614
    },
    {
      icon_id: '11372691',
      name: '筛选',
      font_class: 'shaixuan',
      unicode: 'e8df',
      unicode_decimal: 59615
    },
    {
      icon_id: '11372692',
      name: '商圈',
      font_class: 'shangquan',
      unicode: 'e8e0',
      unicode_decimal: 59616
    },
    {
      icon_id: '11372693',
      name: '删除',
      font_class: 'shanchu',
      unicode: 'e8e1',
      unicode_decimal: 59617
    },
    {
      icon_id: '11372694',
      name: '设置',
      font_class: 'shezhi',
      unicode: 'e8e2',
      unicode_decimal: 59618
    },
    {
      icon_id: '11372695',
      name: '上传',
      font_class: 'shangchuan',
      unicode: 'e8e3',
      unicode_decimal: 59619
    },
    {
      icon_id: '11372696',
      name: '社区',
      font_class: 'shequ',
      unicode: 'e8e4',
      unicode_decimal: 59620
    },
    {
      icon_id: '11372697',
      name: '声音关闭',
      font_class: 'shengyinguanbi',
      unicode: 'e8e5',
      unicode_decimal: 59621
    },
    {
      icon_id: '11372698',
      name: '失败',
      font_class: 'shibai',
      unicode: 'e8e6',
      unicode_decimal: 59622
    },
    {
      icon_id: '11372699',
      name: '时间',
      font_class: 'shijian',
      unicode: 'e8e7',
      unicode_decimal: 59623
    },
    {
      icon_id: '11372700',
      name: '声音',
      font_class: 'shengyin',
      unicode: 'e8e8',
      unicode_decimal: 59624
    },
    {
      icon_id: '11372701',
      name: '收藏',
      font_class: 'shoucang',
      unicode: 'e8e9',
      unicode_decimal: 59625
    },
    {
      icon_id: '11372702',
      name: '手机',
      font_class: 'shouji',
      unicode: 'e8ea',
      unicode_decimal: 59626
    },
    {
      icon_id: '11372703',
      name: '首页',
      font_class: 'shouye',
      unicode: 'e8eb',
      unicode_decimal: 59627
    },
    {
      icon_id: '11372704',
      name: '数据',
      font_class: 'shuju',
      unicode: 'e8ec',
      unicode_decimal: 59628
    },
    {
      icon_id: '11372705',
      name: '刷新',
      font_class: 'shuaxin',
      unicode: 'e8ed',
      unicode_decimal: 59629
    },
    {
      icon_id: '11372706',
      name: '搜索',
      font_class: 'sousuo',
      unicode: 'e8ee',
      unicode_decimal: 59630
    },
    {
      icon_id: '11372707',
      name: '叹号',
      font_class: 'tanhao',
      unicode: 'e8ef',
      unicode_decimal: 59631
    },
    {
      icon_id: '11372708',
      name: '讨论区',
      font_class: 'taolunqu',
      unicode: 'e8f0',
      unicode_decimal: 59632
    },
    {
      icon_id: '11372709',
      name: '添加优惠券',
      font_class: 'tianjiayouhuiquan',
      unicode: 'e8f1',
      unicode_decimal: 59633
    },
    {
      icon_id: '11372710',
      name: '提示',
      font_class: 'tishi',
      unicode: 'e8f2',
      unicode_decimal: 59634
    },
    {
      icon_id: '11372711',
      name: '图片',
      font_class: 'tupian',
      unicode: 'e8f3',
      unicode_decimal: 59635
    },
    {
      icon_id: '11372712',
      name: '退票',
      font_class: 'tuipiao',
      unicode: 'e8f4',
      unicode_decimal: 59636
    },
    {
      icon_id: '11372713',
      name: '未选中',
      font_class: 'weixuanzhong',
      unicode: 'e8f5',
      unicode_decimal: 59637
    },
    {
      icon_id: '11372714',
      name: '微博',
      font_class: 'weibo',
      unicode: 'e8f6',
      unicode_decimal: 59638
    },
    {
      icon_id: '11372715',
      name: '问卷',
      font_class: 'wenjuan',
      unicode: 'e8f7',
      unicode_decimal: 59639
    },
    {
      icon_id: '11372716',
      name: '我的',
      font_class: 'wode',
      unicode: 'e8f8',
      unicode_decimal: 59640
    },
    {
      icon_id: '11372717',
      name: '微信',
      font_class: 'weixin',
      unicode: 'e8f9',
      unicode_decimal: 59641
    },
    {
      icon_id: '11372718',
      name: '我的关注',
      font_class: 'wodeguanzhu',
      unicode: 'e8fa',
      unicode_decimal: 59642
    },
    {
      icon_id: '11372719',
      name: '虾米',
      font_class: 'xiami',
      unicode: 'e8fb',
      unicode_decimal: 59643
    },
    {
      icon_id: '11372720',
      name: '想看',
      font_class: 'xiangkan',
      unicode: 'e8fc',
      unicode_decimal: 59644
    },
    {
      icon_id: '11372721',
      name: '相机',
      font_class: 'xiangji',
      unicode: 'e8fd',
      unicode_decimal: 59645
    },
    {
      icon_id: '11372722',
      name: '消息',
      font_class: 'xiaoxi',
      unicode: 'e8fe',
      unicode_decimal: 59646
    },
    {
      icon_id: '11372723',
      name: '下载',
      font_class: 'xiazai',
      unicode: 'e8ff',
      unicode_decimal: 59647
    },
    {
      icon_id: '11372724',
      name: '小聚场',
      font_class: 'xiaojuchang',
      unicode: 'e900',
      unicode_decimal: 59648
    },
    {
      icon_id: '11372725',
      name: '小食',
      font_class: 'xiaoshi',
      unicode: 'e901',
      unicode_decimal: 59649
    },
    {
      icon_id: '11372726',
      name: '消息中心',
      font_class: 'xiaoxizhongxin',
      unicode: 'e902',
      unicode_decimal: 59650
    },
    {
      icon_id: '11372727',
      name: '银行卡',
      font_class: 'yinhangka',
      unicode: 'e903',
      unicode_decimal: 59651
    },
    {
      icon_id: '11372728',
      name: '眼睛',
      font_class: 'yanjing',
      unicode: 'e904',
      unicode_decimal: 59652
    },
    {
      icon_id: '11372729',
      name: '影城卡',
      font_class: 'yingchengka',
      unicode: 'e905',
      unicode_decimal: 59653
    },
    {
      icon_id: '11372730',
      name: '已想看',
      font_class: 'yixiangkan',
      unicode: 'e906',
      unicode_decimal: 59654
    },
    {
      icon_id: '11372731',
      name: '影评模板',
      font_class: 'yingpingmoban',
      unicode: 'e907',
      unicode_decimal: 59655
    },
    {
      icon_id: '11372732',
      name: '演出',
      font_class: 'yanchu',
      unicode: 'e908',
      unicode_decimal: 59656
    },
    {
      icon_id: '11372733',
      name: '小蜜',
      font_class: 'xiaomi',
      unicode: 'e909',
      unicode_decimal: 59657
    },
    {
      icon_id: '11372734',
      name: '影院',
      font_class: 'yingyuan',
      unicode: 'e90a',
      unicode_decimal: 59658
    },
    {
      icon_id: '11372735',
      name: '增加',
      font_class: 'zengjia',
      unicode: 'e90b',
      unicode_decimal: 59659
    },
    {
      icon_id: '11372736',
      name: '语音',
      font_class: 'yuyin',
      unicode: 'e90c',
      unicode_decimal: 59660
    },
    {
      icon_id: '11372737',
      name: '优惠券',
      font_class: 'youhuiquan',
      unicode: 'e90d',
      unicode_decimal: 59661
    },
    {
      icon_id: '11372738',
      name: 'WIFI',
      font_class: 'WIFI',
      unicode: 'e90e',
      unicode_decimal: 59662
    },
    {
      icon_id: '11372739',
      name: '直播',
      font_class: 'zhibo',
      unicode: 'e90f',
      unicode_decimal: 59663
    },
    {
      icon_id: '11372740',
      name: '优酷会员',
      font_class: 'youkuhuiyuan',
      unicode: 'e910',
      unicode_decimal: 59664
    },
    {
      icon_id: '11372741',
      name: '娱乐宝',
      font_class: 'yulebao',
      unicode: 'e911',
      unicode_decimal: 59665
    },
    {
      icon_id: '11372742',
      name: '指纹',
      font_class: 'zhiwen',
      unicode: 'e912',
      unicode_decimal: 59666
    },
    {
      icon_id: '11372756',
      name: '爱心',
      font_class: 'aixin1',
      unicode: 'e913',
      unicode_decimal: 59667
    },
    {
      icon_id: '11372757',
      name: '成功',
      font_class: 'chenggong1',
      unicode: 'e914',
      unicode_decimal: 59668
    },
    {
      icon_id: '11372758',
      name: '点赞',
      font_class: 'dianzan1',
      unicode: 'e915',
      unicode_decimal: 59669
    },
    {
      icon_id: '11372759',
      name: '电话',
      font_class: 'dianhua1',
      unicode: 'e916',
      unicode_decimal: 59670
    },
    {
      icon_id: '11372760',
      name: '帮助',
      font_class: 'bangzhu1',
      unicode: 'e917',
      unicode_decimal: 59671
    },
    {
      icon_id: '11372761',
      name: '电影票',
      font_class: 'dianyingpiao1',
      unicode: 'e918',
      unicode_decimal: 59672
    },
    {
      icon_id: '11372762',
      name: '发现',
      font_class: 'faxian1',
      unicode: 'e919',
      unicode_decimal: 59673
    },
    {
      icon_id: '11372763',
      name: '定位',
      font_class: 'dingwei1',
      unicode: 'e91a',
      unicode_decimal: 59674
    },
    {
      icon_id: '11372764',
      name: '公告',
      font_class: 'gonggao',
      unicode: 'e91b',
      unicode_decimal: 59675
    },
    {
      icon_id: '11372765',
      name: '话题',
      font_class: 'huati1',
      unicode: 'e91c',
      unicode_decimal: 59676
    },
    {
      icon_id: '11372766',
      name: '减少',
      font_class: 'jianshao1',
      unicode: 'e91d',
      unicode_decimal: 59677
    },
    {
      icon_id: '11372767',
      name: '会员',
      font_class: 'huiyuan1',
      unicode: 'e91e',
      unicode_decimal: 59678
    },
    {
      icon_id: '11372768',
      name: '评论',
      font_class: 'pinglun1',
      unicode: 'e91f',
      unicode_decimal: 59679
    },
    {
      icon_id: '11372769',
      name: '社区',
      font_class: 'shequ1',
      unicode: 'e920',
      unicode_decimal: 59680
    },
    {
      icon_id: '11372770',
      name: '失败',
      font_class: 'shibai1',
      unicode: 'e921',
      unicode_decimal: 59681
    },
    {
      icon_id: '11372771',
      name: '时间',
      font_class: 'shijian1',
      unicode: 'e922',
      unicode_decimal: 59682
    },
    {
      icon_id: '11372772',
      name: '闪电',
      font_class: 'shandian1',
      unicode: 'e923',
      unicode_decimal: 59683
    },
    {
      icon_id: '11372773',
      name: '我的',
      font_class: 'wode1',
      unicode: 'e924',
      unicode_decimal: 59684
    },
    {
      icon_id: '11372774',
      name: '首页',
      font_class: 'shouye1',
      unicode: 'e925',
      unicode_decimal: 59685
    },
    {
      icon_id: '11372775',
      name: '手机',
      font_class: 'shouji1',
      unicode: 'e926',
      unicode_decimal: 59686
    },
    {
      icon_id: '11372776',
      name: '叹号',
      font_class: 'tanhao1',
      unicode: 'e927',
      unicode_decimal: 59687
    },
    {
      icon_id: '11372777',
      name: '收藏',
      font_class: 'shoucang1',
      unicode: 'e928',
      unicode_decimal: 59688
    },
    {
      icon_id: '11372778',
      name: '数据',
      font_class: 'shuju1',
      unicode: 'e929',
      unicode_decimal: 59689
    },
    {
      icon_id: '11372779',
      name: '问答',
      font_class: 'wenda',
      unicode: 'e92a',
      unicode_decimal: 59690
    },
    {
      icon_id: '11372780',
      name: '眼睛',
      font_class: 'yanjing1',
      unicode: 'e92b',
      unicode_decimal: 59691
    },
    {
      icon_id: '11372781',
      name: '影城卡',
      font_class: 'yingchengka1',
      unicode: 'e92c',
      unicode_decimal: 59692
    },
    {
      icon_id: '11372782',
      name: '相机',
      font_class: 'xiangji1',
      unicode: 'e92d',
      unicode_decimal: 59693
    },
    {
      icon_id: '11372783',
      name: '影院',
      font_class: 'yingyuan1',
      unicode: 'e92e',
      unicode_decimal: 59694
    },
    {
      icon_id: '11372784',
      name: '银行优惠',
      font_class: 'yinhangyouhui',
      unicode: 'e92f',
      unicode_decimal: 59695
    },
    {
      icon_id: '11372785',
      name: '小食',
      font_class: 'xiaoshi1',
      unicode: 'e930',
      unicode_decimal: 59696
    },
    {
      icon_id: '11372786',
      name: '演出',
      font_class: 'yanchu1',
      unicode: 'e931',
      unicode_decimal: 59697
    },
    {
      icon_id: '11372787',
      name: '增加',
      font_class: 'zengjia1',
      unicode: 'e932',
      unicode_decimal: 59698
    },
    {
      icon_id: '11372788',
      name: '电影',
      font_class: 'dianying1',
      unicode: 'e933',
      unicode_decimal: 59699
    },
    {
      icon_id: '11372789',
      name: '优惠券',
      font_class: 'youhuiquan1',
      unicode: 'e934',
      unicode_decimal: 59700
    },
    {
      icon_id: '11372790',
      name: '热门',
      font_class: 'remen',
      unicode: 'e935',
      unicode_decimal: 59701
    },
    {
      icon_id: '11372791',
      name: '创作',
      font_class: 'chuangzuo1',
      unicode: 'e936',
      unicode_decimal: 59702
    }
  ]
}
